export default __webpack_public_path__ + "static/media/it_bowl.b6feaf8d.png";